// extracted by mini-css-extract-plugin
module.exports = {"grey200":"#E6E6EC","buttonsContainer":"AnimalButtons_buttonsContainer__SDJkF","button":"AnimalButtons_button__LF1ms"};